<template>
  <div class="avatar-uploader">
    <el-upload
      class="avatar-uploader" 
      :action="action"
      id="filename"
      name="filename"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <el-button size="small" type="primary" class="orgBtn btn-font"><i class="iconfont icon-daochu"></i><label>导入</label></el-button>
    </el-upload>
  </div>
</template>
<script>
import { methodPost } from '../../../api/request.js'
export default {
  name: 'customParams',
  components: {},
  props: {
    action: {
      type: String
    },
    fileType: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {
    /* 导入文件 */
    uploadFile(file) {
      const param = new FormData() // 创建form对象
      if (this.fileType === 'filename') {
        param.append('filename', file)// 通过append向form对象添加数据
      } else if (this.fileType === 'file') {
        param.append('file', file)// 通过append向form对象添加数据
      }
      this.loading = true
      methodPost(this.action, param).then(res => {
        if (res.code === 0) {
          this.handleAvatarSuccess(res, file)
        } else {
          this.uploadError(res.message, file)
        }
      })
    },
    uploadError(err, file) {
      this.loading = true
      this.$message.error('上传失败' + err)
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.$message.success(`导入成功`)
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    beforeAvatarUpload(file) {
      this.loading = true
      const isFile = file.type === 'xls' || 'xlsx'
      if (!isFile) {
        this.$message.error('上传正确的文件格式!')
      } else {
        this.file = file
        this.uploadFile(file)
      }
      return false
    }

  }
}
</script>
<style>
.avatar-uploader{
   display: flex;
}
.avatar-uploader .el-button--small{
    padding-top:0;
    padding-bottom:0;
}
</style>


// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customParams/upload.vue